import { useWindowDimensions } from "react-native";

export function useWindowSize() {
  const window = useWindowDimensions();
  return { height: window.height, width: window.width };
}
